import { Controller } from 'react-hook-form';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { LinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@/entities/user';
import { FormSectionV2, PersonaTextField } from '../../PersonaFormSectionsV2';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function GwiLinkSectionV2() {
  const { t } = useTranslation('audiences');
  const { control } = useEditPersonaFormContext();
  const flagOn = useBooleanFlagValue('gwi_audience_linking', false);
  const { canAccessGwiIntegration } = usePermissions();

  if (!flagOn || !canAccessGwiIntegration) return null;

  return (
    <FormSectionV2
      icon={<LinkIcon className="size-5" />}
      title={t('audiences.gwiLinkSection.gwiAudience')}
    >
      <Controller
        name="gwiId"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <PersonaTextField
            {...field}
            value={field.value ?? ''}
            label={t('audiences.gwiLinkSection.gwiAudienceId')}
            placeholder={t('audiences.gwiLinkSection.eG06e243bcD5244d16')}
            description={t('audiences.gwiLinkSection.pasteTheGwiAudienceUuid')}
            error={error?.message}
          />
        )}
      />
    </FormSectionV2>
  );
}

GwiLinkSectionV2.displayName = 'GwiLinkSectionV2';
